import React from "react";
import { useWatch } from "react-hook-form";

const PatientChip = ({ control, values, handleRemove }) => {
  useWatch({
    control,
  });
  return (
    <ul className="selected-list">
      {values()?.patient_info?.length
        ? values()
            .patient_info.map((row) => JSON.parse(row))
            .map((item, index) => 
              <li key={index}>
                <span>{item.patient_name}</span>
                <span style={{paddingLeft: "10px", color:"#1B2027", fontSize:"14px", cursor:"pointer" }} onClick={()=> handleRemove(index)}>
                  x
                </span>
              </li>)
        : null}
    </ul>
  );
};

export default PatientChip;
